import React from "react";
import "./abouts.scss";
import { Link } from "react-router-dom";

const AboutUs = () => {
  const highlights = [
    {
      icon: "bx bx-code-alt",
      title: "Custom Software Development",
      desc: "Scalable web, mobile, and enterprise solutions tailored for modern businesses."
    },
    {
      icon: "bx bx-cloud",
      title: "Cloud & Infrastructure",
      desc: "Secure cloud migration and managed infrastructure services for business continuity."
    },
    {
      icon: "bx bx-shield-quarter",
      title: "Cyber Security",
      desc: "Advanced protection, compliance, and monitoring solutions to secure digital assets."
    },
    {
      icon: "bx bx-bulb",
      title: "IT Consultancy",
      desc: "Strategic technology consulting to accelerate digital transformation and innovation."
    }
  ];

  const stats = [
    { count: "20+", label: "Projects Delivered" },
    { count: "25+", label: "Happy Clients" },
    { count: "12+", label: "Years Experience" },
    { count: "24/7", label: "Technical Support" }
  ];

  return (
    <section className="about-page">

      <section className="about-hero">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6">
              <div className="hero-content">

                <span className="sub-title">
                  ABOUT GWCS
                </span>

                <h1>
                  Empowering Businesses Through
                  <span> Smart Digital Innovation</span>
                </h1>
                <p>Genius World Consultancy Services (GWCS), established in 2012, delivers innovative software, travel technology, cloud, and enterprise solutions that help businesses grow digitally and improve operational efficiency.</p>

                <p>At GWCS, we combine technical expertise with a client-focused approach to deliver secure, scalable, and future-ready solutions. Our services include web and mobile development, IT consultancy, system integration, and business automation to improve productivity and customer experience.</p>

                <div className="hero-btns">
                  <Link to="/services" className="btn-primary-custom">
                    Explore Services
                  </Link>

                  <Link to="/contact" className="btn-outline-custom text-decoration-none">
                    Contact Us
                  </Link>

                </div>

              </div>
            </div>

            <div className="col-lg-6">
              <div className="hero-image">
                <img
                  src="/assets/images/abouts.jpg"
                  alt="About GWCS"
                  className="img-fluid"
                />

                <div className="experience-box">
                  <h3>12+</h3>
                  <span>Years Experience</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <section className="stats-section">
        <div className="container">
          <div className="stats-wrapper">

            {stats.map((item, index) => (
              <div className="stat-box" key={index}>
                <h2>{item.count}</h2>
                <p>{item.label}</p>
              </div>
            ))}

          </div>
        </div>
      </section>

      <section className="about-info py-5">
        <div className="container">

          <div className="section-title text-center mb-5">
            <span>WHO WE ARE</span>

            <h2>
              Delivering Innovative IT &
              Consultancy Solutions
            </h2>

            <p>
              We specialize in creating intelligent digital solutions
              that help organizations modernize operations, enhance
              customer experiences, and achieve sustainable business growth.
            </p>
          </div>

          <div className="row g-4">

            {highlights.map((item, index) => (
              <div className="col-lg-3 col-md-6" key={index}>

                <div className="about-card">

                  <div className="icon-box">
                    <i className={item.icon}></i>
                  </div>

                  <h4>{item.title}</h4>

                  <p>{item.desc}</p>

                </div>

              </div>
            ))}

          </div>
        </div>
      </section>

      <section className="why-choose-us">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6">
              <img
                src="/assets/images/officepics.webp"
                alt="Why Choose Us"
                className="img-fluid rounded-4"
              />
            </div>

            <div className="col-lg-6">

              <div className="why-content">

                <span className="sub-title">
                  WHY CHOOSE US
                </span>

                <h2>
                  Smart Technology Solutions
                  For Modern Enterprises
                </h2>

                <p>
                  At GWCS, we combine innovation, strategy, and technology
                  expertise to build future-ready digital solutions that
                  empower businesses to grow faster and smarter.
                </p>

                <ul>
                  <li>
                    <i className="bx bx-check-circle"></i>
                    Experienced IT Professionals
                  </li>

                  <li>
                    <i className="bx bx-check-circle"></i>
                    End-to-End Software Solutions
                  </li>

                  <li>
                    <i className="bx bx-check-circle"></i>
                    Agile Development Process
                  </li>

                  <li>
                    <i className="bx bx-check-circle"></i>
                    Continuous Support & Maintenance
                  </li>
                </ul>

              </div>

            </div>

          </div>
        </div>
      </section>

    </section>
  );
};

export default AboutUs;